import addedToFavoritesIcon from '../assets/добавленно в избр.png';
import cartButtonIcon from '../assets/корзина-кнопка.png';

interface FavoriteProductCardProps {
  image: string;
  title: string;
  price: number;
  cartQuantity?: number;
  onRemove?: () => void;
  onAddToCart?: () => void;
  onIncreaseCart?: () => void;
  onDecreaseCart?: () => void;
  onProductClick?: () => void;
}

export default function FavoriteProductCard({
  image,
  title,
  price,
  cartQuantity = 0,
  onRemove,
  onAddToCart,
  onIncreaseCart,
  onDecreaseCart,
  onProductClick,
}: FavoriteProductCardProps) {
  const formatPrice = (value: number) => new Intl.NumberFormat('ru-RU').format(value);

  return (
    <div className="group relative flex h-full min-h-[390px] w-full flex-col overflow-hidden rounded-[18px] bg-white transition-all duration-150 hover:shadow-xl sm:min-h-[520px] sm:rounded-[20px]">
      <button
        type="button"
        className="relative block aspect-[3/4] w-full overflow-hidden bg-white text-left"
        onClick={onProductClick}
      >
        <img
          src={image}
          alt={title}
          className="h-full w-full object-contain bg-white p-[6px] transition-transform duration-200 group-hover:scale-[1.02] sm:p-[8px]"
        />
      </button>

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove?.();
        }}
        className="absolute right-1 top-1 z-10 flex h-[34px] w-[34px] items-center justify-center transition-opacity hover:opacity-80 sm:right-2 sm:top-2 sm:h-[40px] sm:w-[40px]"
      >
        <img src={addedToFavoritesIcon} alt="В избранном" className="h-full w-full" />
      </button>

      <div className="flex flex-1 flex-col bg-white px-2.5 pb-2.5 pt-2 sm:px-4 sm:pb-4 sm:pt-3">
        <button type="button" className="text-left" onClick={onProductClick}>
          <h3
            className="overflow-hidden text-[14px] font-normal leading-[18px] text-black sm:text-[20px] sm:leading-[24px]"
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {title}
          </h3>
        </button>

        <div className="mt-4 flex justify-end">
          <span className="text-[20px] font-bold leading-none text-black sm:text-[26px]">
            {formatPrice(price)} ₽
          </span>
        </div>

        <div className="mt-auto pt-4">
          {cartQuantity > 0 ? (
            <div className="flex h-[46px] w-full items-center justify-between rounded-[18px] bg-white px-3 shadow-[0px_0px_8px_0px_rgba(0,0,0,0.18)] sm:h-[50px] sm:px-[14px]">
              <button
                onClick={onDecreaseCart}
                className="flex h-[34px] w-[34px] items-center justify-center rounded-[10px] transition-colors hover:bg-gray-100"
                aria-label="Уменьшить количество"
              >
                <div className="h-[2px] w-[14px] rounded-[4px] bg-black" />
              </button>
              <span className="min-w-[24px] text-center text-[20px] font-semibold text-black sm:text-[22px]">{cartQuantity}</span>
              <button
                onClick={onIncreaseCart}
                className="relative flex h-[34px] w-[34px] items-center justify-center rounded-[10px] transition-colors hover:bg-gray-100"
                aria-label="Увеличить количество"
              >
                <div className="h-[2px] w-[14px] rounded-[4px] bg-black" />
                <div className="absolute h-[14px] w-[2px] rounded-[4px] bg-black" />
              </button>
            </div>
          ) : (
            <button
              onClick={onAddToCart}
              className="flex h-[44px] w-full items-center justify-center gap-2.5 rounded-[16px] bg-[#5d76cb] transition-all duration-100 hover:bg-[#4d66bb] sm:h-[50px] sm:gap-3 sm:rounded-[18px]"
            >
              <img src={cartButtonIcon} alt="Корзина" className="h-[20px] w-[20px] object-contain sm:h-[24px] sm:w-[24px]" />
              <span className="text-[15px] font-semibold leading-none tracking-[0.8px] text-white sm:text-[20px] sm:tracking-[2px]">
                В корзину
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
